import { EntityWidget } from "./EntityWidget";
import { GeometryPrimitiveEntityController } from "../GeometryPrimitiveEntityController";
import { GeometryPrimitive, SceneConstants } from "@rhinov/savane-js";

export class GeometryPrimitiveEntityWidget extends EntityWidget{

    declare entity: GeometryPrimitive;
    declare controller: GeometryPrimitiveEntityController;

    constructor(entity: GeometryPrimitive, panel: any, deliverable: any) {
        super(entity, panel, deliverable);
        this.controller = new GeometryPrimitiveEntityController(entity, panel, deliverable);
        switch (this.entity.primitiveType) {
            case SceneConstants.GeometryPrimitiveType.box:
            case SceneConstants.GeometryPrimitiveType.triangle:
            case SceneConstants.GeometryPrimitiveType.oval:
            case SceneConstants.GeometryPrimitiveType.halfarc:
                this.propertiesTab = ['plusLess', 'plusLess', 'plusLess', 'plusLess', 'buttonToggle', 'buttonToggle', 'buttonToggle'];
                break;
            case SceneConstants.GeometryPrimitiveType.cylinder:
                this.propertiesTab = ['plusLess', 'plusLess', 'plusLess', 'buttonToggle', 'buttonToggle', 'buttonToggle'];
                break;
            case SceneConstants.GeometryPrimitiveType.sphere:
                this.propertiesTab = ['plusLess', 'plusLess', 'buttonToggle', 'buttonToggle', 'buttonToggle'];
                break;
            case SceneConstants.GeometryPrimitiveType.hood:
                this.propertiesTab = ['plusLess', 'plusLess', 'plusLess', 'plusLess', 'plusLess', 'dropDown', 'plusLess', 'buttonToggle', 'buttonToggle', 'buttonToggle'];
                break;
       }
       this.controller.propertiesTab = this.propertiesTab;
    }

    html(): string {
        var i;
        var html = super.nameHeader() + super.propertyStart();
        for (i = 0; i < this.propertiesTab.length; i++) {
            html += (this as any)[this.propertiesTab[i]](this.panel.properties[i]);
        }
        return html + super.propertyEnd();

    }
}